import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Route,
  withRouter,
  Switch,
} from 'react-router-dom';
import {
  Box,
} from '../../coreui';

import FourOhThree from '../../components/FourOhThree';
import ActiveInvestments from '../activeInvestments';
import PastInvestments from '../pastInvestments';
import WelcomeMessage from '../components/WelcomeMessage';

import actions from './actions';

import {
  BROWSE_PAGE_OPEN_URL,
  BROWSE_PAGE_CLOSED_URL,
} from './links';

class BrowsePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showWelcomeMessage: true,
    };
    this.updateBrowseNavAnimationSettings = this.updateBrowseNavAnimationSettings.bind(this);
    this.closeWelcomeMessage = this.closeWelcomeMessage.bind(this);
  }

  updateBrowseNavAnimationSettings() {
    this.props.updateBrowseNavAnimationSettings();
  }

  closeWelcomeMessage() {
    this.setState({
      showWelcomeMessage: false,
    });
    this.props.closeWelcomeMessageRequested();
  }

  render() {
    const {
      history,
      loaded,
      welcomeMessage,
      accreditationRoleStatus,
      browseNavAnimationSettings,
      showWelcomeMessage,
      isLoggedIn,
      userId,
    } = this.props;

    let redirecting = false;
    if (isLoggedIn === false) {
      redirecting = true;
    }
    if (isLoggedIn && userId) {
      if (accreditationRoleStatus === 'Pre-Accredited') {
        history.replace('/accreditation');
        redirecting = true;
      } else if (!['Non-Accredited', 'Accredited'].includes(accreditationRoleStatus)) {
        return <FourOhThree isLoggedIn />;
      }
    }

    return (
      <Box>
        {
          loaded && !redirecting && showWelcomeMessage && this.state.showWelcomeMessage &&
          <WelcomeMessage
            {...welcomeMessage}
            handleClick={this.closeWelcomeMessage}
          />
        }
        <Switch>
          <Route
            path={BROWSE_PAGE_OPEN_URL}
            render={props => (
              <ActiveInvestments
                {...props}
                redirecting={redirecting}
                browseNavAnimationSettings={browseNavAnimationSettings}
                updateBrowseNavAnimationSettings={this.updateBrowseNavAnimationSettings}
              />
            )}
          />
          {
            loaded && accreditationRoleStatus !== 'Accredited' &&
            <Route
              redirecting={redirecting}
              path={BROWSE_PAGE_CLOSED_URL}
              component={ActiveInvestments}
            />
          }
          {
            (!loaded || accreditationRoleStatus === 'Accredited') &&
            <Route
              path={BROWSE_PAGE_CLOSED_URL}
              render={props => (
                <PastInvestments
                  {...props}
                  browseNavAnimationSettings={browseNavAnimationSettings}
                  updateBrowseNavAnimationSettings={this.updateBrowseNavAnimationSettings}
                />
              )}
            />
          }
        </Switch>
      </Box>
    );
  }
}

BrowsePage.propTypes = {
  history: PropTypes.object,
  loaded: PropTypes.bool,
  accreditationRoleStatus: PropTypes.string,
  browseNavAnimationSettings: PropTypes.object,
  updateBrowseNavAnimationSettings: PropTypes.func,
  showWelcomeMessage: PropTypes.bool,
  welcomeMessage: PropTypes.object,
  closeWelcomeMessageRequested: PropTypes.func,
  firstName: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  userId: PropTypes.number,
  retrying: PropTypes.bool,
};

const mapStateToProps = state => ({
  accreditationRoleStatus: state.browsePage.accreditationRoleStatus,
  gtkyStatus: state.browsePage.gtkyStatus,
  loaded: state.browsePage.loaded,
  browseNavAnimationSettings: state.browsePage.browseNavAnimationSettings,
  showWelcomeMessage: state.browsePage.showWelcomeMessage,
  welcomeMessage: state.browsePage.welcomeMessage,
  isLoggedIn: state.browsePage.isLoggedIn,
  userId: state.browsePage.userId,
  retrying: state.browsePage.retrying,
});

const mapDispatchToProps = dispatch => ({
  updateBrowseNavAnimationSettings: () => {
    dispatch(actions.updateBrowseNavAnimationSettings());
  },
  closeWelcomeMessageRequested: () => {
    dispatch(actions.closeWelcomeMessageRequested());
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrowsePage));
